export enum SLOT_PROVIDER {
  OCTOPLAY = "OCTOPLAY",
  NOLIMITCITY = "NOLIMITCITY",
  PENGUIN_KING = "PENGUIN_KING",
  BAD_DECISION_GAMING = "BAD_DECISION_GAMING",
  BACKSEAT = "BACKSEAT",
  JUSTSLOTS = "JUSTSLOTS",
  HACKSAW = "HACKSAW",
  ANIMO = "ANIMO",
  WICKED = "WICKED",
  BULLSHARK = "BULLSHARK",
  EVOSLOTGAMING = "EVOSLOTGAMING",
}

export const SLOT_PROVIDER_READABLE: Record<SLOT_PROVIDER, string> = {
  [SLOT_PROVIDER.OCTOPLAY]: "Octoplay",
  [SLOT_PROVIDER.NOLIMITCITY]: "Nolimit City",
  [SLOT_PROVIDER.JUSTSLOTS]: "Just Slots",
  [SLOT_PROVIDER.BACKSEAT]: "Backseat",
  [SLOT_PROVIDER.HACKSAW]: "Hacksaw Gaming",
  [SLOT_PROVIDER.PENGUIN_KING]: "Penguin King",
  [SLOT_PROVIDER.ANIMO]: "Animo",
  [SLOT_PROVIDER.WICKED]: "Wicked",
  [SLOT_PROVIDER.BULLSHARK]: "Bull Shark",
  [SLOT_PROVIDER.BAD_DECISION_GAMING]: "Bad Decision Gaming",
  [SLOT_PROVIDER.EVOSLOTGAMING]: "Evoslotgaming",
};

export const SlotBlobUrl = "https://wrewards.s3.eu-north-1.amazonaws.com/slots_nw";

export function getSlotImageUrl(confirmedRelativeKey: string | null | undefined): string | null {
  return confirmedRelativeKey ? `${SlotBlobUrl}/${confirmedRelativeKey}` : null;
}
